import React from "react";

const HealthCheck: React.FC = () => {
  return <div>OK</div>;
};

export default HealthCheck;
